const discoverActionTypes = {
  GET_DISCOVER_START: "GET_DISCOVER_START",
  GET_DISCOVER_SUCCESS: "GET_DISCOVER_SUCCESS",
  GET_DISCOVER_FAILURE: "GET_DISCOVER_FAILURE",
  GET_DISCOVER_BY_CATEGORY_START: "GET_DISCOVER_BY_CATEGORY_START",
  GET_DISCOVER_BY_CATEGORY_SUCCESS: "GET_DISCOVER_BY_CATEGORY_SUCCESS",
  GET_DISCOVER_BY_CATEGORY_FAILURE: "GET_DISCOVER_BY_CATEGORY_FAILURE",
  GET_DISCOVER_BY_SEARCH_START: "GET_DISCOVER_BY_SEARCH_START",
  GET_DISCOVER_BY_SEARCH_SUCCESS: "GET_DISCOVER_BY_SEARCH_SUCCESS",
  GET_DISCOVER_BY_SEARCH_FAILURE: "GET_DISCOVER_BY_SEARCH_FAILURE",
};

export default discoverActionTypes;
